import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { ElementType } from "react";
import { useNavigate } from "react-router-dom";
interface DeleteHelperProps {
    helperId?: string;
    helperName: string
    deleteHelper: (id: string) => Promise<boolean>;
    setDeleting: (value: string | undefined) => void;
}

export const DeleteHelper: ElementType<DeleteHelperProps> = 
({ helperId, helperName, deleteHelper, setDeleting }) => {

    const navigate = useNavigate();
    const handleDelete = async () => {
        if (helperId !== undefined) {
            const success = await deleteHelper(helperId);
            if (success) {
              navigate('/helpers');
            }
            setDeleting(undefined);
        }
        setDeleting(undefined);
      };

    return (
        <Dialog
            open={helperId !== undefined}
            onClose={() => setDeleting(undefined)}
        >
            <DialogTitle>Delete Helper</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete "{helperName}"? This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDeleting(undefined)}>
                    Cancel
                </Button>
                <Button onClick={handleDelete} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}